export enum JobSource {
  DIRECT = "direct",
  ATS = "ats",
}

export enum JobStatus {
  PUBLISHED = "published",
  UNPUBLISHED = "unpublished",
}

export enum JobVisibility {
  LIVE = "live",
  SCHEDULED = "scheduled",
  EXPIRED = "expired",
}

export enum WorkplaceType {
  NOT_SPECIFIED = "not_specified",
  ON_SITE = "on_site",
  HYBRID = "hybrid",
  REMOTE = "remote",
}

export enum JobType {
  NOT_SPECIFIED = "not_specified",
  FULL_TIME = "full_time",
  PART_TIME = "part_time",
  PERMANENT = "permanent",
  FIXED_TERM = "fixed_term",
  TEMPORARY = "temporary",
  INTERNSHIP = "internship",
  STUDENT_JOB = "student_job",
  FREELANCE = "freelance",
}

export enum Currency {
  DKK = "DKK",
  SEK = "SEK",
  NOK = "NOK",
  EUR = "EUR",
}

export enum SalaryPeriod {
  MONTH = "month",
  YEAR = "year",
  HOUR = "hour",
}

export enum ApplyType {
  URL = "url",
  EMAIL = "email",
}

export type Salary = {
  currency: Currency | null;
  from: number | null;
  to: number | null;
  period: SalaryPeriod | null;
};

export type ContactPerson = {
  name: string;
  title: string;
  email: string;
  phone: string;
};

export type DirectJobForm = {
  title: string;
  department: string | null;
  category: string | null;
  location: string | null;
  workplace_type: WorkplaceType;
  job_type: JobType;
  application_deadline: string | null;
  salary: Salary | null;
  ad_text: string | null;
  banner_url: string | null;
  contact_persons: ContactPerson[];
  apply: { type: ApplyType; url: string; email: string } | null;
  job_ad_template_id: string | null;
  show_from: string | null;
  show_until: string | null;
};

export type DirectJob = {
  job_id: string;
  source: JobSource.DIRECT;
  status: JobStatus;
  visibility: JobVisibility | null;
  public_url: string | null;
  created_at: string;
  updated_at: string;
  form: DirectJobForm;
};

export type JobListItem = {
  job_id: string;
  title: string;
  source: JobSource;
  status: JobStatus;
  visibility: JobVisibility | null;
  public_url: string | null;
  updated_at: string;
};
